<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-checkbox v-model="checkAll" :label="`Выбрать все уровни и все параметры`"></v-checkbox>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-for="parameterSet in model" :key="parameterSet.id">
      <h5 class="content-title text-color">
        Тип уровня:
        <span class="text-danger">{{ parameterSet.level_type }}</span> Значение:
        <span class="text-danger">{{ parameterSet.level }}</span>
      </h5>
      <input type="hidden" v-model="parameterSet.level_type" />
      <input type="hidden" v-model="parameterSet.level" />

      <v-checkbox v-model="parameterSet.checked" :label="`Выбрать все`"></v-checkbox>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Выбрать</th>
              <th>Название</th>
              <th>Ед.измерения</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="parameter in parameterSet.parameters" :key="parameter.sname">
              <td class="p-l-20">
                <v-checkbox v-model="parameter.checked"></v-checkbox>
              </td>
              <td>{{ parameter.pname }}</td>
              <td>{{ parameter.unit }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "SelectedParameterList",
  props: {
    model: Array
  },
  computed: {
    checkAll: {
      get: function() {
        if (this.model.length) {
          return !this.model.some(x => !x.checked);
        }

        return false;
      },
      set: function(value) {
        this.model.forEach(x => (x.checked = value));
      }
    }
  }
};
</script>